import React from "react";
import "./actor.css";

const ProfileTabs = ({ activeTab, handleTabClick, role }) => {
  return (
    <div className="log-profile-tabs">
      {role === "actor" || role ==="crew" ? (
        <>
          <button
            className={activeTab === "info" ? "active" : ""}
            onClick={() => handleTabClick("info")}
          >
            INFO
          </button>
          <button
            className={activeTab === "assets" ? "active" : ""}
            onClick={() => handleTabClick("assets")}
          >
            REELS
          </button>
        </>
      ):(
        <>
        </>
      )}
    </div>
  );
};

export default ProfileTabs;
